import React from 'react';

type ContentContainerProps = {
  children: React.ReactNode;
};

function ContentContainer({ children }: ContentContainerProps): JSX.Element {
  return <div className="content">{children}</div>;
}

export default ContentContainer;
